/**
 * Generates OAuth authorization URLs for different social login platforms
 * @param {string} platform - The platform identifier ('microsoft', 'facebook', 'google', 'apple', 'apple-mobile')
 * @returns {URL} URL object containing the complete OAuth authorization URL
 *
 * Constructs OAuth URLs with:
 * - Client IDs from environment variables
 * - Redirect URIs (base URL for most platforms, specific URLs for Apple)
 * - Required OAuth parameters (response_type, scope)
 * - Platform-specific configurations (tenant ID for Microsoft, version for Facebook)
 */

export const getAuthUrl = (platform) => {

  const BASE_REDIRECT_URI = `${window.location.origin}${window.location.pathname}`;
  const APPLE_REDIRECT_URI = process.env.REACT_APP_APPLE_REDIRECT_URI;
  const APPLE_MOBILE_REDIRECT_URI = process.env.REACT_APP_APPLE_MOBILE_REDIRECT_URI;

  const OAUTH_URLS = {
    microsoft: `https://login.microsoftonline.com/${
      process.env.REACT_APP_MICROSOFT_TENANT_ID || "common"
    }/oauth2/v2.0/authorize?client_id=${
      process.env.REACT_APP_MICROSOFT_CLIENT_ID
    }&redirect_uri=${BASE_REDIRECT_URI}&response_type=code&scope=user.read`,

    facebook: `https://www.facebook.com/v13.0/dialog/oauth?client_id=${process.env.REACT_APP_FACEBOOK_APP_ID}&redirect_uri=${BASE_REDIRECT_URI}&response_type=code&scope=public_profile email`,

    google: `https://accounts.google.com/o/oauth2/v2/auth?client_id=${process.env.REACT_APP_GOOGLE_SOCIAL_CLIENT_ID}&redirect_uri=${BASE_REDIRECT_URI}&response_type=code&scope=openid profile email`,

    apple: `https://appleid.apple.com/auth/authorize?client_id=${
      process.env.REACT_APP_APPLE_CLIENT_ID
    }&redirect_uri=${APPLE_REDIRECT_URI}&response_type=code&scope=name email&response_mode=form_post`,

    "apple-mobile": `https://appleid.apple.com/auth/authorize?client_id=${
      process.env.REACT_APP_APPLE_CLIENT_ID
    }&redirect_uri=${APPLE_MOBILE_REDIRECT_URI}&response_type=code&scope=name email&response_mode=form_post`,
  };

  const authUrl = OAUTH_URLS[platform];

  return new URL(authUrl);
};
